import React, { useState } from 'react';
import Modal from './Modal';
import { sections } from './Dashboard';
import '../style/Hero.scss'
export default function Hero() {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [formData, setFormData] = useState({ name: '', userPhone: '',userEmail:'', targetAdminPhone: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch('/send-registration', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            if (res.ok) {
                alert("Հայտը հաջողությամբ ուղարկվեց:");
                setIsFormOpen(false);
                setFormData({ name: '', userPhone: '', targetAdminPhone: '', userEmail:'' });
            }
        } catch (err) {
            alert("Սխալ՝ կապ հաստատեք մեզ հետ հեռախոսով:");
        }
    };

    return (
        <section className="hero">
            <h1>Կերտիր քո ապագան <span className="highlight">«ARDA»</span> կրթական կենտրոնի հետ</h1>
            <p>Որակյալ կրթություն և պրակտիկ հմտություններ:</p>

            <div className="hero-btns">
                <a href="#courses" className="btn-main">Դասընթացներ</a>
                <button onClick={() => setIsFormOpen(true)} className="btn-sub">Անվճար խորհրդատվություն</button>
            </div>

            {isFormOpen && (
                <Modal onClose={() => setIsFormOpen(false)}>
                    <div className="auth-form">
                        <h2>Գրանցում</h2>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text" placeholder="Անուն Ազգանուն" required
                                onChange={e => setFormData({ ...formData, name: e.target.value })}
                            />
                            <input
                                type="tel" placeholder="Հեռախոս" required
                                onChange={e => setFormData({ ...formData, userPhone: e.target.value })}
                            />
                            <input
                                type="email" placeholder="Էլ. հասցե" required
                                onChange={e => setFormData({ ...formData, userEmail: e.target.value })}
                            />
                            <select
                                required
                                onChange={e => setFormData({ ...formData, targetAdminPhone: e.target.value })}
                            >
                                <option value="">Ընտրեք մասնագիտությունը</option>
                                {sections.map(s => <option key={s.id} value={s.tel}>{s.title}</option>)}
                            </select>
                            <button type="submit" className="submit-btn">Ուղարկել</button>
                        </form>
                    </div>
                </Modal>
            )}
        </section>
    );
}